import React, { useState } from "react";
import Grid from '@mui/material/Grid';
import CustomDialog from "../../../../components/Dialog/DiaComp";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import GetMicro from "./GetMicro"


export default function DiaOverview() {


    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
    <Grid container>
        <Tooltip title="Microbiome Overview" placement="bottom">
            <IconButton onClick={handleOpen} >
                <AccessibilityIcon sx={{color: 'common.white', '&:hover': { color: 'primary.light'}, }}/>
            </IconButton>   
        </Tooltip>
    </Grid>

    <CustomDialog open={open} onClose={handleClose}

          title="Microbiome Overview"
          content = { <Grid container sx={{display: 'flex', justifyContent: 'center'}}> <GetMicro /> </Grid>}

        />
        
</>
)}